<rt-group variant="horizontal stacked">
  @if (buttonMode === 'batchSelect') {
    <rt-bulk-actions-batch-select [variant]="variant" />
  }

  @if (active) {
    <!-- visible actions buttons -->
    @for (action of visibleActions; track trackByAction($index, action)) {
      <rt-button
        (click)="dispatchAction(action)"
        [disabled]="isActionInProgress(action)"
        [loading]="isActionInProgress(action)"
        [variant]="variant"
      >
        <rt-icon [name]="action.buttonIcon!" size="small-x" />
        <rt-truncate>{{ action.buttonLabel }}</rt-truncate>
      </rt-button>
    }

    <!-- hidden actions dropdown -->
    @if (hiddenActions.length > 0) {
      <rt-button
        #moreBulkActionsDropdownTrigger="rtOverlayOrigin"
        [dropdownOpened]="dropdownOpen"
        rt-overlay-origin
        [variant]="variant"
        (click)="toggleDropdown(!dropdownOpen)"
      >
        {{
          visibleActions.length === 0
            ? ('app.bulk_actions.button_actions' | translate)
            : ('app.bulk_actions.button_actions_more' | translate)
        }}
      </rt-button>
      <ng-template
        #moreBulkActionsDropdown="rtConnectedOverlay"
        rt-connected-overlay
        [rtConnectedOverlayAutoClose]="false"
        hasBackdrop
        [origin]="moreBulkActionsDropdownTrigger"
        [open]="dropdownOpen"
        (backdropClick)="toggleDropdown(false)"
      >
        <rt-dropdown
          [style.maxHeight]="dropdownHeight"
          [style.overflow]="'auto'"
          [width]="DropdownWidth.SmallX"
        >
          <rt-scrollable>
            @for (action of hiddenActions; track trackByAction($index, action)) {
              <rt-dropdown-item (click)="dispatchAction(action); toggleDropdown(false)">
                <rt-icon prefix [name]="action.buttonIcon!" />{{ action.buttonLabel }}
              </rt-dropdown-item>
            }
          </rt-scrollable>
        </rt-dropdown>
      </ng-template>
    }
  }

  @if (buttonMode === 'toggle') {
    <rt-button
      [class.primary]="active"
      [class.default]="!active"
      (click)="toggleActive()"
      class="bulk-toggle"
      [variant]="variant"
    >
      <rt-checkbox [style.pointerEvents]="'none'" [checked]="active" />
      <span class="text">
        {{ 'app.bulk_actions.label' | translate }}
        @if (selectedItems.length > 0) {
          ({{ selectedItems.length }})
        }
      </span>
    </rt-button>
  }
</rt-group>

@if (active) {
  <rt-icon-button
    (click)="clearSelection()"
    variant="plain"
    shape="square"
    iconName="close"
    margin-left-small-xxx
  />
}
